import React, { Component } from 'react';
export default class Unit_Price_Chart extends Component {
    constructor(props) {
        super(props);
        this.arr = [];
    }

    render() {
        let info = this.props.info;

        this.arr = [];
        for (let x = 0; x < 97; x++) { //generate 96 blocks - 1 block = 15 mins interval
            if (x % 16 == 0) { //for every 4 hours display time
                if ((x / 4) < 10) { //if hours is a single digit - add 0 infront 
                    this.arr.push({ color: '#FFFFFF', time: '0' + (x / 4) + ':00' });
                } else {
                    this.arr.push({ color: '#FFFFFF', time: (x / 4) + ':00' });
                }
            } else {
                this.arr.push({ color: '#FFFFFF', time: '' });
            }
        }

        if (info != null) {
            // Iterate keys of json object on reverse
            for (var keys = Object.keys(info), i = keys.length - 1, end = 0; i >= end; i--) {
                var key = keys[i];

                let from = info[key].period[0];
                if (from == null) from = 0;

                let to = info[key].period[1];
                if (to == null) to = 0;

                if (from == to) continue;

                let start_time = 0;
                let end_time = 0;
                if (from < to) {
                    start_time = from;
                    end_time = to;
                } else {
                    start_time = to;
                    end_time = from;
                }

                start_time = "" + start_time;
                end_time = "" + end_time;

                let start_time_length = start_time.length;
                let end_time_length = end_time.length;

                for (let j = 0; j < 4 - start_time_length; j++) {
                    start_time = "0" + start_time;
                }

                for (let k = 0; k < 4 - end_time_length; k++) {
                    end_time = "0" + end_time;
                }

                let start_time_hour = parseInt(start_time.charAt(0) + start_time.charAt(1));
                let start_time_mins = parseInt(start_time.charAt(2) + start_time.charAt(3));
                let end_time_hour = parseInt(end_time.charAt(0) + end_time.charAt(1));
                let end_time_mins = parseInt(end_time.charAt(2) + end_time.charAt(3));

                let start_tile_position = (start_time_hour * 4) + (start_time_mins / 15);
                let end_tile_position = (end_time_hour * 4) + (end_time_mins / 15);
                let color = "#FFFFFF";
                // Set the color of the chart
                for (let tile_position = start_tile_position; tile_position <= end_tile_position; tile_position++) {
                    if (info[key].enable) { //if zone is enabled
                        switch (key) {
                            case 'zone1':
                                color = "#FF0000";
                                break;
                            case 'zone2':
                                color = "#FFFF00";
                                break;
                            case 'zone3':
                                color = "#4169E1";
                                break;
                            case 'zone4':
                                color = "#00FF00";
                                break;
                            case 'zone5':
                                color = "#FFE4E1";
                                break;
                        }
                        this.arr[tile_position].color = color;
                    }
                }
            }
        }
        return (
            <div style={{ margin: 20, width: '100%', height: 100, paddingRight: 30 }}>
                {Object.keys(this.arr).map((obj, index) => {
                    return (
                        <div style={{ display: 'inline-block', width: '1%', height: '100%' }}>
                            <span style={{ display: 'block', transform: 'rotate(-45deg)', fontSize: 12 }}>{this.arr[obj].time}</span>
                            <div style={{ display: 'inline-block', background: this.arr[obj].color, width: '100%', height: '50%' }}>
                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

}

